class nav {
	constructor() {
		
	}
	fixMobileScroll(el) {
		$(el).on('show.bs.collapse hide.bs.collapse', e => {
			if (e.target.isSameNode(el)) {
				const body = document.querySelector('body');
				const html = document.querySelector('html');
				const bodyScrollTop = body.scrollTop;
				[body, html].forEach(element => {
					if (!element.classList.contains('block-scroll')) {
						body.setAttribute('data-scroll-top', body.scrollTop);
					}
					element.classList.toggle('block-scroll');
					if (!element.classList.contains('block-scroll')) {
						if (body.getAttribute('data-scroll-top') !== '') {
							const scrollTop = parseInt(body.getAttribute('data-scroll-top'));
							body.scrollTop = scrollTop;
							body.setAttribute('data-scroll-top', '');
						}
					}
				});
			}
		});
	}
	mobileNavChildrenState(el) {
		const elementsWithChildren = Array.from(el.querySelectorAll('.has-children'));
		elementsWithChildren.forEach(elementWithChildren => {
			const collapseableDescendant = elementWithChildren.querySelector('.collapse');
			$(collapseableDescendant).on('show.bs.collapse hide.bs.collapse', e => {
				if (e.target.isSameNode(collapseableDescendant)) {
					elementWithChildren.classList.toggle('showing-children', e.type == 'show');
				}
			});
		});
	}
	normalizeDropdownHeight(el) {
		const dropdownMenus = Array.from(el.querySelectorAll('.nav-item.dropdown .dropdown-menu'));
		const minHeight = dropdownMenus.map(element => {
			element.style.opacity = 0;
			element.classList.add('show');
			const height = element.offsetHeight;
			element.classList.remove('show');
			element.style.opacity = 1;
			return height;
		}).reduce((minHeight, currentHeight) => {
			return minHeight < currentHeight ? currentHeight : minHeight;
			}, 0);
		dropdownMenus.forEach(element => {
			element.style.height = '1px';
			element.style.minHeight = `${minHeight}px`;
		});
	}
}

window.app.add('nav', new nav());